export function getEnv() {
    let envLocation = window.location.origin;

    switch (envLocation) {
        case "http://localhost:3000":
        case "http://127.0.0.1:3000":
            return {
                // Empty = relative /api/* URLs; setupProxy.js forwards to hosted backend.
                ENDPOINT: '',
                KEYCLOAK_URL: 'http://tfgbv.esafety.org.lk',
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak',
            }

        case "http://tfgbv.esafety.org.lk":
            return {
                ENDPOINT: 'http://tfgbv.esafety.org.lk',
                KEYCLOAK_URL: 'http://tfgbv.esafety.org.lk',
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak', // jwt or 'keycloak' http://esafety.org.lk/
                CLIENT_SECRET: 'RgUKrKvgLrCuZyV3JQsNiXSM2oRY0Mi3'
            }

        case "https://tfgbv.esafety.org.lk":
            return {
                ENDPOINT: 'https://tfgbv.esafety.org.lk',
                KEYCLOAK_URL: 'https://tfgbv.esafety.org.lk',
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak', // jwt or 'keycloak' http://esafety.org.lk/
                CLIENT_SECRET: 'RgUKrKvgLrCuZyV3JQsNiXSM2oRY0Mi3'
            }
        // return {
        //     ENDPOINT: 'http://tfsgbv.esafety.lk',
        //     KEYCLOAK_URL: 'http://tfsgbv.esafety.lk',
        //     REALM: 'TFGBVRealm',
        //     CLIENT_ID: 'TFGBVClient',
        //     ENVIRONMENT: 'production',
        //     DEBUG_MODE: true,
        //     LOG_LEVEL: 'debug',
        //     AUTH_METHOD: 'keycloak', // jwt or 'keycloak' http://tfsgbv.esafety.lk/
        //     CLIENT_SECRET: 'RgUKrKvgLrCuZyV3JQsNiXSM2oRY0Mi3'
        // }

        case "http://localhost:3001":
            return {
                ENDPOINT: '',
                KEYCLOAK_URL: 'http://18.224.32.110',
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak'
            }
        // TFGBV Live
        case "http://esafety.org.lk":
            return {
                ENDPOINT: 'http://esafety.org.lk',
                KEYCLOAK_URL: 'http://esafety.org.lk',
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak', // jwt or 'keycloak' http://esafety.org.lk/
                CLIENT_SECRET: 'RgUKrKvgLrCuZyV3JQsNiXSM2oRY0Mi3'
            }

        case "https://esafety.org.lk":
            return {
                ENDPOINT: 'https://esafety.org.lk',
                KEYCLOAK_URL: 'https://esafety.org.lk',
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak', // jwt or 'keycloak' http://esafety.org.lk/
                CLIENT_SECRET: 'RgUKrKvgLrCuZyV3JQsNiXSM2oRY0Mi3'
            }

        default:
            return {
                ENDPOINT: envLocation,
                KEYCLOAK_URL: envLocation,
                REALM: 'TFGBVRealm',
                CLIENT_ID: 'TFGBVClient',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak', // jwt or 'keycloak' http://esafety.org.lk/
                CLIENT_SECRET: 'RgUKrKvgLrCuZyV3JQsNiXSM2oRY0Mi3'
            }
    }
}

// Helper function to get environment variable with fallback
export function getEnvVar(key, defaultValue = '') {
    const env = getEnv();
    return env[key] || defaultValue;
}

// Helper function to check if we're in development mode
export function isDevelopment() {
    return getEnv().ENVIRONMENT === 'development';
}

// Helper function to check if debug mode is enabled
export function isDebugMode() {
    return getEnv().DEBUG_MODE === true;
}